import React, { useState } from "react"
import { TextField, Button, Box, Typography } from "@mui/material";
import SubjectForm from "./SubjectForm";
import '../i18n';
import { useTranslation } from 'react-i18next';
import ErrorIcon from '@mui/icons-material/Error';
import { useUser } from '../context/UserContext';


export default function ClientForm({ createSession, roomId = null }) {
    const [t, i18n] = useTranslation();
    const [groupError, setGroupError] = useState(false);
    const [subjectError, setSubjectError] = useState(false);

    const userContext = useUser();

    let isFullForm = roomId === null;

    const handleGroupChange = e => {
        if (e.target.validity.valid) {
            setGroupError(false);
        } else {
            setGroupError(true);
        }
    };

    const checkFormBeforeSubmit = () => {
        if (!groupError && !subjectError) { createSession(roomId) }
    }

    // TODO: change to FormControl 
    // TODO: add instructions for filling up
    return (
        <Box className="client_form" sx={{ bgcolor: 'background.paper' }}>
            <Box sx={{ margin: '30px', display: 'flex' }}>
                <Box>
                    <Box className="client_input">
                        <TextField
                            id="name"
                            variant="outlined"
                            label={t("ФИО")}
                            className="text_field"
                            defaultValue={userContext.get_name()}
                            inputProps={{ readOnly: true }}
                        />
                    </Box>

                    <Box className="client_input">
                        <TextField
                            id="group"
                            variant="outlined"
                            label={t("Группа")}
                            className="text_field"
                            defaultValue={userContext.get_group()}
                            inputProps={{
                                pattern: "[0-9]{4}",
                            }}
                            onChange={handleGroupChange}
                            error={groupError}
                            helperText={
                                groupError ? "Группа должна состоять из 4 цифр" : ""
                            }
                        />
                    </Box>
                    <Button
                        variant="contained"
                        className="client_accept"
                        onClick={checkFormBeforeSubmit}
                    >
                        {t("Создать сессию")}
                    </Button>
                </Box>

                <Box sx={{ marginLeft: '30px' }}>
                    {isFullForm ? (
                        <>
                            <Box className="client_input">
                                <SubjectForm setSubjectFormError={setSubjectError}/>
                            </Box>
                            <Box className="client_input">
                                <TextField
                                    id="title"
                                    variant="outlined"
                                    label={t("Название работы")}
                                    className="text_field"
                                />
                            </Box>
                        </>
                    ) : null}
                </Box>
            </Box>
        </Box>
    )
}